import { render, staticRenderFns } from "./TipoProcessoSelect.vue?vue&type=template&id=6c3f32dc&"
import script from "./TipoProcessoSelect.vue?vue&type=script&lang=js&"
export * from "./TipoProcessoSelect.vue?vue&type=script&lang=js&"
import style0 from "./TipoProcessoSelect.vue?vue&type=style&index=0&id=6c3f32dc&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports